<template>
  <div class="noti-bell-wrapper">
    <!-- Bell button -->
    <button
      id="noti-bell-btn"
      class="noti-bell-btn"
      type="button"
      :title="unreadCount > 0 ? `${unreadCount} thông báo chưa đọc` : 'Thông báo'"
      @click.stop="toggleDropdown"
    >
      <icon icon="fa-solid fa-bell" />
      <!-- Unread badge -->
      <span v-if="unreadCount > 0" class="noti-badge">{{ badgeCount() }}</span>
    </button>

    <!-- Notifications dropdown -->
    <div
      v-if="isOpen"
      class="noti-dropdown"
      @click.stop
    >
      <!-- Header -->
      <div class="noti-dropdown-header">
        <h6 class="noti-dropdown-title">
          <icon icon="fa-solid fa-bell" class="me-2" style="opacity: 0.7;" />
          Thông báo
        </h6>
        <button
          class="noti-mark-all-btn"
          type="button"
          :disabled="unreadCount === 0"
          @click="markAllAsRead"
        >
          Đánh dấu tất cả đã đọc
        </button>
      </div>

      <!-- Loading state -->
      <div v-if="isLoading" class="noti-loading">
        <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
        <span>Đang tải thông báo...</span>
      </div>

      <!-- Notification list -->
      <div v-else-if="notifications.length > 0" class="noti-list">
        <div
          v-for="noti in notifications"
          :key="noti.id"
          class="noti-item"
          :class="{ unread: isNotiUnread(noti) }"
          @click="onNotificationClick(noti)"
        >
          <!-- Actor avatar -->
          <img
            v-if="isValidAvatar(noti.actorAvatar)"
            :src="getAvatarSrc(noti.actorAvatar)"
            :alt="noti.actorName"
            class="noti-actor-avatar"
            @error="onAvatarError($event)"
          />
          <div v-else class="noti-actor-avatar-fallback">
            {{ getInitial(noti.actorName) }}
          </div>

          <!-- Text content -->
          <div class="noti-item-body">
            <p class="noti-item-text">
              <span class="noti-actor-name">{{ noti.actorName }}</span>
              {{ ' ' + getNotificationText(noti) }}
            </p>
            <p v-if="noti.content" class="noti-item-preview">
              "{{ noti.content }}"
            </p>
            <p class="noti-item-time">
              <icon icon="fa-solid fa-clock" class="me-1" style="font-size: 0.65rem;" />
              {{ formatTime(noti.createTime) }}
            </p>
          </div>

          <!-- Unread indicator dot -->
          <span v-if="isNotiUnread(noti)" class="noti-unread-dot" aria-hidden="true"></span>
        </div>

        <!-- Load more -->
        <div v-if="hasMore()" class="noti-footer">
          <button
            class="noti-load-more-btn"
            type="button"
            :disabled="isLoadingMore"
            @click="loadMore"
          >
            <span v-if="isLoadingMore">
              <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Đang tải...
            </span>
            <span v-else>Xem thêm thông báo</span>
          </button>
        </div>
      </div>

      <!-- Empty state -->
      <div v-else class="noti-empty">
        <div class="noti-empty-icon">
          <icon icon="fa-solid fa-bell-slash" />
        </div>
        <p class="noti-empty-text">Bạn chưa có thông báo nào</p>
      </div>
    </div>
  </div>
</template>

<script src="./NotificationBell.js"></script>
<style scoped src="./NotificationBell.css"></style>
